import * as yup from 'yup';
import { ObjectShape } from 'yup/lib/object';

const createSchema = (isEdit?: boolean): yup.ObjectSchema<ObjectShape> => {
  let schemaObject: ObjectShape = {};

  if (isEdit) {
    schemaObject = {
      annotation: yup.string().notRequired(),
      note: yup.string().required('Campo obbligatorio'),
    };
  } else {
    schemaObject = {
      annotation: yup.string().required('Campo obbligatorio'),
      note: yup.string().required('Campo obbligatorio'),
    };
  }

  return yup.object().shape(schemaObject);
};

export default createSchema;
